import type { Permission } from '@almacen/shared';
import { Center, Loader } from '@mantine/core';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { ForbiddenPage } from '../components/ForbiddenPage';
import { useAuth } from './auth-context';

/** Exige sesión; si no la hay, redirige al login recordando la página pedida. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }
  if (!user)
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return children;
}

/** Oculta una página si el usuario no tiene el permiso (la API lo vuelve a comprobar). */
export function RequirePermission({
  permission,
  children,
}: {
  permission: Permission;
  children: ReactNode;
}) {
  const { can } = useAuth();
  return can(permission) ? children : <ForbiddenPage />;
}
